/* eslint no-param-reassign: 0 */

export const formatNumber = window.App.helpers.formatNumber;
export const compareCatalogNumbers = ({ findArtworkFunction }) => {
  const compare = (liveAuctionA, liveAuctionB) => {
    const regexStrings = /\d+|\D+/g;
    const regexDigits = /\d/;

    liveAuctionA = findArtworkFunction(liveAuctionA.artwork).catalogNumber.toUpperCase();
    liveAuctionB = findArtworkFunction(liveAuctionB.artwork).catalogNumber.toUpperCase();

    const liveAuctionAParts = liveAuctionA.match(regexStrings);
    const liveAuctionBParts = liveAuctionB.match(regexStrings);

    const bothLiveAuctionsContainOrNotContainDigits = regexDigits.test(liveAuctionA)
     === regexDigits.test(liveAuctionB);

    if (liveAuctionAParts && liveAuctionBParts && bothLiveAuctionsContainOrNotContainDigits) {
      const length = Math.min(liveAuctionAParts.length, liveAuctionBParts.length);
      for (let i = 0; i < length; i += 1) {
        let liveAuctionAPart = liveAuctionAParts[i];
        let liveAuctionBPart = liveAuctionBParts[i];

        const isDigitPart = regexDigits.test(liveAuctionAPart) &&
          regexDigits.test(liveAuctionBPart);

        if (isDigitPart) {
          liveAuctionAPart = parseInt(liveAuctionAPart, 10);
          liveAuctionBPart = parseInt(liveAuctionBPart, 10);
        }

        if (liveAuctionAPart !== liveAuctionBPart) {
          return liveAuctionAPart < liveAuctionBPart ? -1 : 1;
        }
      }
    }

    return (liveAuctionA >= liveAuctionB) - (liveAuctionA <= liveAuctionB);
  };
  return compare;
};
export const tableRowNumber = (page, perPage, index) => {
  const rowNumber = ((page - 1) * perPage) + index + 1;
  return rowNumber;
};
export const findElementById = (list, id) => {
  const element = list.filter(el => el.id === id)[0];
  return element;
};
export const compareAuctionType = (auctionsCatalog, typeName) => {
  const compare = auctionsCatalog.auction_type === typeName;
  return compare;
};
export const compareAuctionStatus = (auctionsCatalog, statusName) => {
  const compare = auctionsCatalog.status === statusName;
  return compare;
};



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/helpers.js